var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/naming-convention */
import { useEffect, useState, useMemo } from 'react';
import api from '@utils/axios';
import { translate } from '@utils/i18n';
import { namespace, emptyFrequencyString } from './constants';
import { backFlowTypesPath, backFlowTypePath } from '../../../../routes';
import toast from 'react-hot-toast';
function useBackFlowTypes(searchText, frequencies) {
    const [backFlowTypes, setBackFlowTypes] = useState([]);
    const [loading, setLoading] = useState(false);
    const sortByDisplayName = (types) => [...types].sort((a, b) => a.displayName.localeCompare(b.displayName, undefined, { sensitivity: 'base' }));
    const getBackFlowTypes = () => __awaiter(this, void 0, void 0, function* () {
        setLoading(true);
        try {
            const res = yield api.get(backFlowTypesPath({ format: 'json' }));
            const types = res.data.backFlowTypes;
            setBackFlowTypes(sortByDisplayName(types));
        }
        finally {
            setLoading(false);
        }
    });
    useEffect(() => {
        getBackFlowTypes();
    }, []);
    const updateBackFlowType = (backFlowType) => __awaiter(this, void 0, void 0, function* () {
        try {
            yield api.patch(`${backFlowTypePath(backFlowType.id)}.json`, {
                back_flow_type: {
                    display_name: backFlowType.displayName,
                    active: backFlowType.active,
                    territory_ids: backFlowType.territoryIds,
                    has_all_frequencies: backFlowType.hasAllFrequencies,
                    frequency_ids: backFlowType.frequencyIds
                }
            });
            const frequencyString = backFlowType.hasAllFrequencies
                ? translate('all', { namespace: 'generic' })
                : frequencies
                    .filter(({ value }) => backFlowType.frequencyIds.includes(value))
                    .map(({ label }) => label)
                    .join(', ');
            setBackFlowTypes((prev) => sortByDisplayName(prev.map((t) => t.id === backFlowType.id
                ? Object.assign(Object.assign({}, t), { displayName: backFlowType.displayName, active: backFlowType.active, territoryIds: backFlowType.territoryIds, hasAllFrequencies: backFlowType.hasAllFrequencies, frequencyIds: backFlowType.frequencyIds, frequencyString: frequencyString || emptyFrequencyString }) : t)));
            toast.success(translate('update_success', { namespace }));
            return true;
        }
        catch (e) {
            toast.error(translate('update_failure', { namespace }));
            return false;
        }
    });
    const addBackFlowType = (backFlowType) => {
        setBackFlowTypes((prev) => sortByDisplayName([...prev, backFlowType]));
    };
    const filteredBackFlowTypes = useMemo(() => {
        if (!searchText.trim())
            return backFlowTypes;
        const lowerSearch = searchText.toLowerCase();
        return backFlowTypes.filter(({ displayName, frequencyString, template }) => [displayName, frequencyString, template === null || template === void 0 ? void 0 : template.country, template === null || template === void 0 ? void 0 : template.state, template === null || template === void 0 ? void 0 : template.city].some((field) => field === null || field === void 0 ? void 0 : field.toLowerCase().includes(lowerSearch)));
    }, [searchText, backFlowTypes]);
    return {
        backFlowTypes: filteredBackFlowTypes,
        loading,
        updateBackFlowType,
        addBackFlowType
    };
}
export default useBackFlowTypes;
